import React from 'react';
import { IconProps } from '../types';

export const Car: React.FC<IconProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 15H30M28 23V26C28 26.2652 27.8946 26.5196 27.7071 26.7071C27.5196 26.8946 27.2652 27 27 27H24C23.7348 27 23.4804 26.8946 23.2929 26.7071C23.1054 26.5196 23 26.2652 23 26V23M28 23H4M28 23V15L24.2625 6.6C24.1849 6.42229 24.0574 6.27096 23.8954 6.16444C23.7334 6.05791 23.5439 6.00078 23.35 6H8.65C8.45611 6.00078 8.26662 6.05791 8.10461 6.16444C7.9426 6.27096 7.81506 6.42229 7.7375 6.6L4 15V23M9 23V26C9 26.2652 8.89464 26.5196 8.70711 26.7071C8.51957 26.8946 8.26522 27 8 27H5C4.73478 27 4.48043 26.8946 4.29289 26.7071C4.10536 26.5196 4 26.2652 4 26V23M8 19H10M22 19H24"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
